import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const dashboardApi = createApi({
    reducerPath: 'dashboardApi',
    baseQuery: EnhancedBaseQuery,
    tagTypes: ['Dashboard'],
    endpoints: (builder) => ({
        opticianNotificationsList: builder.mutation({
            query: () => ({
                url: '/eyetests/optician/notificationslist',
                method: 'POST',
            }),
        }),
        
        // Updated endpoint - calls without parameters
        dashboardMonthlyCount: builder.query({
            query: () => ({
                url: '/eyetests/monthlydashboardcount',
                method: 'GET',
                // No body needed, backend should return current month's data
            }),
            providesTags: ['Dashboard'],
        }),
    }),
});

export const { 
    useOpticianNotificationsListMutation,
    useDashboardMonthlyCountQuery
} = dashboardApi;

export default dashboardApi;